import axios from 'axios'

const baseURL = 'https://api.filecharkh.com/'

export const config = () => {
    axios.defaults.baseURL = baseURL
    axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
    // axios.defaults.withCredentials = true
}


export const files = 'api/v1/file/public?page=:page&sort=:sort'
export const types = 'api/v1/filetype/list'
export const properties = 'api/v1/fileProperty/list'
export const tags = 'api/v1/tag/list'
export const random = 'api/v1/user/random'
export const moshaveran = 'api/v1/user/moshaveran'









